export var HttpContentType;
(function (HttpContentType) {
    HttpContentType["APPLICATION_JSON"] = "application/json";
    HttpContentType["APPLICATION_JSON_PATCH"] = "application/json-patch+json";
    HttpContentType["APPLICATION_PDF"] = "application/pdf";
    HttpContentType["TEXT_HTML"] = "text/html";
    HttpContentType["APPLICATION_ZIP"] = "application/zip";
    HttpContentType["APPLICATION_OCTET_STREAM"] = "application/octet-stream";
    HttpContentType["TEXT_XML"] = "text/xml";
    HttpContentType["APPLICATION_FORM_URLENCODED"] = "application/x-www-form-urlencoded";
})(HttpContentType || (HttpContentType = {}));
//# sourceMappingURL=HttpContentType.js.map